import { RemoveShoppingCartIcon, Skeleton, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import type { CardCancellationReasonProps } from './card-cancellation-reason.type'

import styles from './card-cancellation-reason.module.css'

const CardCancellationReasonDefault = ({
  cancellationReason,
  cancellationDescription,
}: CardCancellationReasonProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenSupplyOrderDetail')

  return (
    <div className={styles.core}>
      <div className={styles.title}>
        <RemoveShoppingCartIcon />
        <Text variant="title-base">
          {t('tabGeneralCardCancellationReasonTitle')}
        </Text>
      </div>

      <div className={styles.content}>
        <Text variant="title-base" className={styles.reason}>
          <strong>{t('tabGeneralCardCancellationReasonReasonTitle')}</strong>
          {cancellationReason
            ? tEnums(
                `supply_order_status_cancelled_reason_${cancellationReason}`,
              )
            : '-'}
        </Text>
        <Text variant="title-base" className={styles.observation}>
          <strong>
            {t('tabGeneralCardCancellationReasonObservationTitle')}
          </strong>
          {cancellationDescription || '-'}
        </Text>
      </div>
    </div>
  )
}

const CardCancellationReasonLoading = () => {
  const { t } = useTranslation('screenSupplyOrderDetail')
  return (
    <div className={styles.core}>
      <div className={styles.title}>
        <RemoveShoppingCartIcon />
        <Text variant="title-base">
          {t('tabGeneralCardCancellationReasonTitle')}
        </Text>
      </div>

      <div className={styles.content}>
        <Text variant="title-base" className={styles.reason}>
          <strong>{t('tabGeneralCardCancellationReasonReasonTitle')}</strong>
          <Skeleton width="60%" height="1rem" />
        </Text>
        <Text variant="title-base" className={styles.observation}>
          <strong>
            {t('tabGeneralCardCancellationReasonObservationTitle')}
          </strong>
          <Skeleton width="60%" height="1rem" />
        </Text>
      </div>
    </div>
  )
}

export const CardCancellationReason = (props: CardCancellationReasonProps) => {
  if (props.isLoading) {
    return <CardCancellationReasonLoading />
  }

  return <CardCancellationReasonDefault {...props} />
}
